import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addTeacherFormSchema = z
  .object({
    name: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.addTeacher.name.required)
      .min(2, VALIDATION_MESSAGES.addTeacher.name.min)
      .max(100, VALIDATION_MESSAGES.addTeacher.name.max),

    email: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.addTeacher.email.required)
      .min(5, VALIDATION_MESSAGES.addTeacher.email.min)
      .max(100, VALIDATION_MESSAGES.addTeacher.email.max)
      .refine(
        (val) =>
          /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
            val
          ),
        { message: VALIDATION_MESSAGES.addTeacher.email.invalid }
      ),

    countryCode: z.string().nonempty(VALIDATION_MESSAGES.countryCode.invalid),

    phone_number: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.mobileNumber.required)
      .min(4, VALIDATION_MESSAGES.mobileNumber.invalid)
      .max(15, VALIDATION_MESSAGES.mobileNumber.invalid)
      .regex(/^\d+$/, VALIDATION_MESSAGES.mobileNumber.invalid),

    assignedClasses: z.array(z.string()).optional(),

    sendCredentials: z.boolean().optional(),
  })
  .refine(
    (data) => {
      // Validate complete phone number with country code
      try {
        const fullPhoneNumber = `${data.countryCode}${data.phone_number}`;
        return isValidPhoneNumber(fullPhoneNumber);
      } catch {
        return false;
      }
    },
    {
      message: VALIDATION_MESSAGES.mobileNumber.invalid,
      path: ['phone_number'], // Show error on phone_number field
    }
  );

export type TAddTeacherForm = z.infer<typeof addTeacherFormSchema>;
